import clsx from 'clsx';
export function Metal({ metal, className }: { metal: string; className: string }) {
  const colorClass = ['white_gold', 'platinum', '14K white gold', 'Platinum'].includes(metal)
    ? 'from-gray-300 via-gray-100 to-gray-400'
    : ['yellow_gold', '14K yellow gold'].includes(metal)
      ? 'from-[#D4AF37]/80 via-[#D4AF37]/30 to-[#D4AF37]'
      : ['rose_gold', '14K rose gold'].includes(metal)
        ? 'from-[#DEA193]/80 via-[#DEA193]/30 to-[#DEA193]'
        : null;
  return (
    <div
      className={clsx(className || '', colorClass, 'bg-linear-to-br rounded-full shadow-xl')}
    ></div>
  );
}
